import type { ReactNode } from "react";

import Box from "@mui/material/Box";
import type { DialogProps } from "@mui/material/Dialog";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export type ModalProps = {
  title?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
} & DialogProps;

const Modal = ({ title, children, actions, ...props }: ModalProps) => (
  <Dialog
    {...props}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    keepMounted={false}
  >
    {title && (
      <DialogTitle
        data-component="Title"
        sx={{ pb: 0.5, px: { xs: 1, sm: 2 }, pt: { xs: 1, sm: 2 } }}
        id="alert-dialog-title"
      >
        {title}
      </DialogTitle>
    )}
    <DialogContent sx={{ px: { xs: 1, sm: 2 }, py: { xs: 1, sm: 2 } }}>
      <Box sx={{ pt: { xs: 0.5, sm: 1 } }}>{children}</Box>
    </DialogContent>
    {actions && (
      <DialogActions
        sx={{
          paddingX: { xs: 1, sm: 3 },
          paddingY: { xs: 1, sm: 2 },
        }}
      >
        {actions}
      </DialogActions>
    )}
  </Dialog>
);

export default Modal;
